import { useEffect, useState } from 'react';
import { apiGet } from '../api/api';
import Card from '../components/Card';

export default function MyCards() {
    const [cards, setCards] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        apiGet('/my_cards.php')
            .then(d => {
                if (d.status === 'ok') setCards(d.cards || []);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, []);

    if (loading) return <p>Načítám karty...</p>;
    if (!cards.length) return <p>Nemáš žádné karty.</p>;

    return (
        <div className="cards-grid">
            {cards.map(card => (
                <Card key={card.card_id} card={card} />
            ))}
        </div>
    );
}
